import { TargetDecisionScope } from '@/models/adobe-target';
import { AnalyticsEvent } from '../models';

export class ExperienceRequestEvent implements AnalyticsEvent {
  name = 'ExperienceRequestEvent';
  constructor(public readonly viewName: string, public readonly decisionScopes?: TargetDecisionScope[]) {}
}